import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolderBookmarks: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"folder-bookmarks"} maskId="square-filled-radius-0-stroke-1-IconFolderBookmarks"><path fillRule="evenodd" clipRule="evenodd" d="M2 3H10.2676L12.2676 6H22V20H9V12H2V3Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M1 13H8V21.309L4.5 19.559L1 21.309V13Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFolderBookmarks;
